export default {
  INVALID_PHONE_ERROR: 'That phone number is invalid.',
  CONFIRM_PHONE_ERROR: 'Please confirm the contact phone number.',
  TOO_MANY_ATTEMPTS_CODE: 'attempt-limit-reached',
};
